// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-content-lightestblue[data-v-41c51546] {\n  --bg-opacity: 1;\n  background-color: #E5ECF6;\n  background-color: rgba(229, 236, 246, var(--bg-opacity));\n}\n", ""]);
// Exports
module.exports = exports;
